<template>
  <el-dialog 
    ref="maxDialog" 
    custom-class="dialogHeightFull maxDialog" 
    :title="title" 
    :fullscreen="fullFlag"
    :visible.sync="maxdialogVisible" 
    :append-to-body="true" 
    :close-on-click-modal="false" 
    :modal="false"
    :show-close="false"
    :width="width" 
    :top="top"
    v-if="maxdialogVisible" 
    @closed="closeMaxDialog" 
    v-dialogDrag
  >
    <div slot="title" class="maxDialog-header">
      <div class="maxDialog-title"><span>{{title}}</span></div>
      <div class="maxDialog-icon">
        <i :class="fullFlag? 'titleIconMin' : 'titleIconMax' " @click="IsFullscreen"></i>
        <i class="titleIconClose" @click="closeMaxDialog"></i>
      </div>
    </div>
    <slot name="content" :style="{height:height}"></slot>
    <div class="resize"></div>
  </el-dialog>
</template>
<script>
  export default {
    name: 'maxDialog',
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      titleVisible: {
        type: Boolean,
        default: true
      },
      width: {
        type: String,
        default: '1200px'
      },
      height: {
        type: String,
        default: '100%'
      },
      top: {
        type: String,
        default: '70vh'
      },
      title: {
        type: String,
        default: ''
      },
      isfullscreen: {
        type: Boolean,
        default: false // 默认全屏
      }
    },
    data() {
      return {
        full: false, // 全屏
      }
    },
    computed: {
      fullFlag: {
        get: function() {
          return this.full ? this.full : this.isfullscreen;
        },
        set: function() {
          return this.full
        }
      },
      maxdialogVisible:{ //重新设置一个变量，接收父级传递的参数
        get:function(){
          return this.dialogVisible
        },
        set :function(){
          this.$emit('update:dialogVisible', false)
        }
      }
    },
    mounted() {
    },
    methods: {
      // 全屏 切换
      IsFullscreen() {
        let dialogDom = document.querySelector(".maxDialog");
        if (this.isfullscreen == true) {
          this.full = this.full === null ? false : !this.full
        } else {
          this.full = this.full === null ? true : !this.full
          dialogDom.style.top =`0px`;
          dialogDom.style.left =`auto`;
        }
        // 传过来的全屏钩子函数
        this.$emit('maxFun')
      },
      // 关闭
      closeMaxDialog() {
        this.full = null
        this.$emit('dialogVisibleSend', false)
        // 传过来的关闭钩子函数
        this.$emit('closeFun')
      }
    },
    created() {
      this.full = this.isfullscreen
    },
  }
</script>
<style lang="less" scoped="scoped">
  /deep/.el-dialog__header {
    background-color: #f2f2f2;
    /* height: 48px; */
    padding: 10px 20px 10px 20px;
  }
  .maxDialog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items:center;
  }
  .maxDialog .maxDialog-icon i {
    display: inline-block;
    height: 16px;
    width: 16px;
    // line-height: 24px;
    text-align: center;
    // border-radius: 50%;
    cursor: pointer;
    // font-size: 22px;
    background-size: contain;
  }
  .maxDialog .maxDialog-icon i:hover {
    background-color: #ddd;
  }
  .maxDialog .maxDialog-icon i::before {
    font-size: 80%;
  }
  /deep/.maxDialog.dialogHeightFull.el-dialog {
    margin-bottom: 0;
    overflow-y: hidden;
  }
  .el-dialog__wrapper{
    overflow: hidden!important;
  }
  .resize{
    position: absolute;
    right: 0;
    bottom: 0;
    content: '';
    width: 10px;
    height: 10px;
    cursor: se-resize;
  }

  // 弹窗头部(最大化、最小化)
  .titleIconMax {
    background: url(../../assets/img/sysNotice/sysnotice-max.png);
  }
  .titleIconMin {
    background: url(../../assets/img/sysNotice/sysnotice-min.png);
  }
  .titleIconClose {
    background: url(../../assets/img/sysNotice/sysnotice-close.png);
    margin-left: 10px;
  }
  .titleIcon {
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
    background-position: center;
  }
  /deep/.maxDialog.el-dialog {
    margin: auto 0 0 auto;
  }
</style>

